import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPetugasLms = 'petugas-lms';
const getDetailPetugasLms = 'petugas-lms/';
const getPetugasLmsTidakAktif = 'petugas-lms';
const postPetugasLmsUrl = 'petugas-lms';
const putPetugasLms = 'petugas-lms/';
const deletePetugasLms = 'petugas-lms/';
const exportPetugasLms = 'petugas-lms-export';

class PetugasLmsService {
    getPetugasLms(currentPage) {
        return axios.get(
            API_URL + getPetugasLms + '?page=' + currentPage + 'size=5',
            {
                headers: authHeader()
            });
    }

    getPetugasLmsAktif(currentPage, pageSize, filter) {
        return axios.get(            
            API_URL + getPetugasLms + '?status=1' + '&pageNo=' + currentPage + '&pageSize=' + pageSize + '&sortBy=id' + '&filter=' + filter,
            {
                headers: authHeader()
            }
        );
    }

    getPetugasLmsTidakAktif(currentPage, pageSize, filter) {
        return axios.get(            
            API_URL + getPetugasLmsTidakAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&sortBy=id' + '&filter=' + filter + '&status=0',
            {
                headers: authHeader()
            }
        );
    }

    postPetugasLms(formData) {        
        try {
            let form = new FormData();
            form.append('username', formData.username);
            form.append('name', formData.name);
            form.append('email', formData.email);
            form.append('password', formData.password);
            form.append('noTelephone', formData.noTelephone);
            form.append('status', formData.status);            
            form.append('tipePetugas', 'lms');                          
            form.append('divisi.idDivisi', formData.idDivisi);                                
            form.append('cabang.idCabang', formData.idCabang);        
            if (typeof formData.foto !== 'undefined') {
                form.append('foto', formData.foto);
            }

            if(formData.roles && formData.roles.length > 0) {                
                for (let i = 0; i < formData.roles.length; i++) {
                    const role = formData.roles[i];
                    form.append(`roles[${i}].roleName`, role.nama_role);
                    form.append(`roles[${i}].statusCreate`, role.status_create);
                    form.append(`roles[${i}].statusRead`, role.status_read);
                    form.append(`roles[${i}].statusUpdate`, role.status_update);
                    form.append(`roles[${i}].statusDelete`, role.status_delete);
                    form.append(`roles[${i}].statusExportPdf`, true);
                    form.append(`roles[${i}].statusExportExcel`, role.status_export_excel);
                }
            }            
            
            return axios.post(API_URL + postPetugasLmsUrl, form, {
                headers: {
                    'Content-Type': 'multipart/form-data', 
                    'Authorization': tokenHeader()
                }
            });
        } catch (error) {
            // comment console console.log(error)
        }
    }

    getDetailPetugasLms(id) {
        return axios.get(API_URL + getDetailPetugasLms + id, {
            headers: authHeader()
        });
    }

    putPetugasLms(formData) {
        try {
            let form = new FormData();
            form.append('username', formData.username);
            form.append('name', formData.name);
            form.append('email', formData.email);
            form.append('password', formData.password);
            form.append('noTelephone', formData.noTelephone);
            form.append('status', formData.status);
            form.append('tipePetugas', 'lms');
            form.append('divisi.idDivisi', formData.idDivisi);                                
            form.append('cabang.idCabang', formData.idCabang);                                  
            if (typeof formData.foto !== 'undefined') {
                form.append('foto', formData.foto);
            }
            if(formData.foto) {
                form.append('foto', formData.foto);
            }

            if(formData.roles && formData.roles.length > 0) {                
                for (let i = 0; i < formData.roles.length; i++) {
                    const role = formData.roles[i];
                    // comment console console.log(role)
                    form.append(`roles[${i}].roleName`, role.nama_role);
                    form.append(`roles[${i}].statusCreate`, role.status_create);
                    form.append(`roles[${i}].statusRead`, role.status_read);
                    form.append(`roles[${i}].statusUpdate`, role.status_update);
                    form.append(`roles[${i}].statusDelete`, role.status_delete);
                    form.append(`roles[${i}].statusExportPdf`, true);
                    form.append(`roles[${i}].statusExportExcel`, role.status_export_excel);
                }
            }            
            
            return axios.put(API_URL + putPetugasLms + formData.id, form, {
                headers: {
                    'Content-Type': 'multipart/form-data', 
                    'Authorization': tokenHeader()
                }
            });
        } catch (error) {
            // comment console console.log(error)
        }
    }

    deletePetugasLms(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePetugasLms + formData.id,
                { headers: authHeader() }
            );
    }

    exportPetugasLmsAktif() {
        return axios.get(API_URL + exportPetugasLms + '?status=1', {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    exportPetugasLmsTidakAktif() {
        return axios.get(API_URL + exportPetugasLms + '?status=0', {
            headers: authHeader(),
            responseType: 'blob'
        });
    }    
}

export default new PetugasLmsService();